import { Router } from "@angular/router";
import { catchError, from, Observable } from "rxjs";
import { AuctionService } from "../services/auction.service";

export function initializeCoreFactory(auctionService: AuctionService, router: Router): () => Observable<any> {
  return () => auctionService.getDefaultData().pipe(
    catchError(() => from(router.navigate['/']))
  )
}